// Shared formatting: display strings for humans, stable values for the server.

export function digitsOnly(s) {
  return (s || "").replace(/\D/g, "");
}

// U.S. phone: returns up to 10 national digits (drops a leading country-code 1). Extra digits are kept so validation can reject them.
export function phoneDigits(raw) {
  let d = digitsOnly(raw);
  if (d.length > 10 && d.startsWith("1")) d = d.slice(1);
  return d;
}

export function formatPhone(raw) {
  const d = phoneDigits(raw);
  if (!d) return "";
  if (d.length <= 3) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  if (d.length <= 10) return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6, 10)} ${d.slice(10)}`;
}

export function phoneError(raw) {
  const d = phoneDigits(raw);
  if (!d) return "Required";
  if (d.length < 10) return "Enter all 10 digits";
  if (d.length > 10) return "Too many digits for a U.S. number";
  if (d[0] === "0" || d[0] === "1") return "Enter a valid U.S. area code";
  return "";
}

// Money: keep digits and at most one decimal point (max 2 decimals). Returns "" for blank.
export function moneyDigits(raw) {
  let s = (raw || "").replace(/[^\d.]/g, "");
  const i = s.indexOf(".");
  if (i >= 0) s = s.slice(0, i + 1) + s.slice(i + 1).replace(/\./g, "").slice(0, 2);
  return s;
}

export function formatMoney(raw) {
  const s = moneyDigits(raw);
  if (!s) return "";
  const [int, dec] = s.split(".");
  const grouped = (int || "0").replace(/^0+(?=\d)/, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `$${grouped}${dec !== undefined ? `.${dec}` : ""}`;
}

export function moneyValue(raw) {
  const s = moneyDigits(raw);
  if (!s || s === ".") return null;
  return Number(s);
}

export function moneyDisplay(num) {
  if (num === null || num === undefined || num === "") return "";
  return formatMoney(String(num));
}

// Capitalize the first letter of each name part once; keeps the rest as typed (O'Brien, de la Cruz stays as the user corrects it).
export function capitalizeName(s) {
  return (s || "").replace(/(^|[\s'-])(\p{Ll})/gu, (m, sep, ch) => sep + ch.toUpperCase());
}

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export function emailError(v) {
  const s = (v || "").trim();
  if (!s) return "Required";
  if (!EMAIL_RE.test(s)) return "Enter a valid email address like name@example.com";
  return "";
}

export const US_STATES = ["AL","AK","AZ","AR","CA","CO","CT","DE","DC","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"];

export function yearOptions() {
  const now = new Date().getFullYear();
  const out = [];
  for (let y = now; y >= 1900; y -= 1) out.push(String(y));
  return out;
}
